var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{staticClass:"flag",staticStyle:{"background-image":"url(/GB.png)"},attrs:{"alt":"EN"}}),_vm._v("EN ")])}]

export { render, staticRenderFns }